import { useCallback } from 'react';

import { WidgetConfiguration, useSlackForwardingSettings } from '@hotjar/integrations';
import type { Settings } from '@hotjar/webapp/features/Forwarding/ForwardToSlack';
import type { SegmentId } from '@hotjar/webapp/features/Recordings/types';
import type { SiteId } from '@hotjar/site';

import type { FormMode } from '../FormModeOption';

export function useSlackForwardingSettingsWithSave(
  currentSiteId: SiteId,
  segmentId: SegmentId | null,
  formMode: FormMode,
): [Settings | null, (newSettings: Settings) => void, (segmentId?: SegmentId) => Promise<void>] {
  const effectiveSegmentId = formMode === 'update' ? segmentId : null;

  const [settings, setSettings] = useSlackForwardingSettings(
    currentSiteId,
    'recording_segment',
    effectiveSegmentId,
  );

  const saveSettings = useCallback(
    async (segmentIdToSave = effectiveSegmentId) => {
      if (segmentIdToSave === null || settings === null) {
        throw Error('Cannot save settings');
      }

      // TODO: cancel request somehow when the component unmounts
      await WidgetConfiguration.update(
        currentSiteId,
        'recording_segment',
        segmentIdToSave,
        settings,
      );
    },
    [settings, currentSiteId, effectiveSegmentId],
  );

  return [settings, setSettings, saveSettings];
}
